import { render } from "./ListExhibitorsView.vue?vue&type=template&id=623ad467"
import script from "./ListExhibitorsView.vue?vue&type=script&lang=js"
export * from "./ListExhibitorsView.vue?vue&type=script&lang=js"

import "./ListExhibitorsView.vue?vue&type=style&index=0&id=623ad467&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__